var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{staticStyle:{"padding-bottom":"110px"}},[_c('v-row',[_c('v-col',{staticClass:"px-0 mt-sm-5 mx-auto",attrs:{"cols":"12","sm":"11","md":"10","lg":"7"}},[(_vm.entity != null)?_c('CompanyPage',{attrs:{"entityParent":_vm.entity,"inDialog":false}}):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }